import { createAction } from 'redux-actions';

export const getAllOrderLivestreamRequested = createAction('GET_ALL_ORDER_LIVESTREAM_REQUESTED');
export const getAllOrderLivestreamRequestedReceived = createAction('GET_ALL_ORDER_LIVESTREAM_REQUESTED_RECEIVED');
export const getAllOrderLivestreamRequestedReceivedFailure = createAction('GET_ALL_ORDER_LIVESTREAM_REQUESTED_RECEIVED_FAILURE');
export const clearOrderLivestreamData = createAction('CLEAR_ORDER_LIVESTREAM_DATA');

export const getDetailOrderLivestreamRequested = createAction('GET_DETAIL_ORDER_LIVESTREAM_REQUESTED');
export const getDetailOrderLivestreamRequestedReceived = createAction('GET_DETAIL_ORDER_LIVESTREAM_REQUESTED_RECEIVED');
export const getDetailOrderLivestreamRequestedReceivedFailure = createAction('GET_DETAIL_ORDER_LIVESTREAM_REQUESTED_RECEIVED_FAILURE');
export const clearDetailOrderLivestreamData = createAction('CLEAR_DETAIL_ORDER_LIVESTREAM_DATA');

export const updateStatusLivestreamRequested = createAction('UPDATE_STATUS_LIVESTREAM_REQUESTED');
export const updateStatusLivestreamRequestedReceived = createAction('UPDATE_STATUS_LIVESTREAM_REQUESTED_RECEIVED');
export const updateStatusLivestreamRequestedReceivedFailure = createAction('UPDATE_STATUS_LIVESTREAM_REQUESTED_RECEIVED_FAILURE');
export const clearStatusLivestream = createAction('CLEAR_STATUS_LIVESTREAM');

export const resentMailLivestreamRequested = createAction('RESENT_MAIL_LIVESTREAM_REQUESTED');
export const resentMailLivestreamRequestedReceived = createAction('RESENT_MAIL_LIVESTREAM_REQUESTED_RECEIVED');
export const resentMailLivestreamRequestedReceivedFailure = createAction('RESENT_MAIL_LIVESTREAM_REQUESTED_RECEIVED_FAILURE');
export const clearMailLivestream = createAction('CLEAR_MAIL_LIVESTREAM');
